import React from "react";
import { FaStar } from "react-icons/fa";
import Footer from "../components/Footer";
import Header from "../components/Header";
import boy from "../img/men.png";
import baby from "../img/baby.png";
import main from "../img/main.png";
import logo1 from "../img/image 39.png";
import logo2 from "../img/image 40.png";
import logo3 from "../img/image 41.png";
import logo4 from "../img/image 42.png";
import red from "../img/redCross.png";
import reds from "../img/cross.png";
import aboutImg from "../img/about.jpg";
import Review from "../components/Review";
import Package from "../components/Package";

const reviews = [
  {
    text: "We switched to AngelWatch from another program, and the difference is night and day. This is the best emergency training available.",
    name: "Michael Trent",
    work: "Charter School Director",
  },
  {
    text: "After completing AngelWatch’s training, I finally feel like I know exactly what to do if an emergency happens.",
    name: "Jessica Ramirez",
    work: "Preschool Teacher",
  },
  {
    text: "After taking the AngelWatch course, I finally feel prepared for any emergency—and that peace of mind is truly priceless.",
    name: "Emily Harris",
    work: "Kindergarten Teacher",
  },
];

export default function About() {
  return (
    <>
      <Header />
      <div className="">
        {/* Top Section */}

        <div className="relative text-white">
          {/* Hero Image */}
          <div className="lg:h-[354px] h-[150px] w-full overflow-hidden">
            <img
              src={main}
              alt="How it works"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content Overlay */}

          <div className="absolute inset-0 flex items-center justify-start">
            <div className="max-w-7xl w-full mx-auto px-4">
              <div className="flex flex-col">
                <h1
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[61px] text-[24px] font-bold mb-2 text-white"
                >
                  About Us
                </h1>
                <div style={{ fontFamily: "Poppins" }} className="text-white">
                  Home &gt; <span className="text-white">About Us</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Protect Your Children Section */}
        <div className="bg-white text-gray-800 font-sans">
          <div className="max-w-7xl p-1 mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <h2
                style={{ fontFamily: "Fredoka" }}
                className="lg:text-[34px] text-[28px] text-black font-semibold mb-4"
              >
                A Legacy of Protection,
                <br />
                Now for Education
              </h2>
              <p
                style={{ fontFamily: "poppins" }}
                className="mb-4 text-black text-[18px]"
              >
                AngelWatch was founded in 2015 with a singular mission: to bring
                proven government-level emergency preparedness to the
                environments that care for our youngest citizens.
              </p>
              <p
                style={{ fontFamily: "poppins" }}
                className="mb-4 text-black text-[18px]"
              >
                Our founder, Mr. Dave Vitalli, is a Department of Defense
                contractor and U.S. veteran with a decorated service history. He
                has consulted the DOD, various Homeland Defense offices, and the
                Department of Homeland Security, and helped implement
                large-scale government preparedness across 22 world governments.
              </p>
              <p
                style={{ fontFamily: "poppins" }}
                className="mb-4 text-black text-[18px]"
              >
                After U.S. emergency planning was redesigned for federal
                buildings, our team strongly recommended its adaptation for
                schools.
              </p>
            </div>

            <div className="flex justify-center md:justify-end">
              <img
                src={aboutImg}
                alt="Founder"
                className="rounded-xl shadow-md w-[500px] h-[600px] h-auto"
              />
            </div>
          </div>
          <div className="max-w-7xl p-2 mx-auto mt-4 mb-4">
            <p
              style={{ fontFamily: "poppins" }}
              className="mb-4 text-black text-[18px]"
            >
              Mr. Vitalli used the same government-grade standards and designed
              AngelWatch to be the first emergency management certification
              platform that matches the preparedness of U.S. security agencies.
            </p>
            <p
              style={{ fontFamily: "poppins" }}
              className="mb-4 text-black text-[18px]"
            >
              Now, every school and center in the U.S. can access that same
              protection. AngelWatch is built for education—but developed by
              national defense experts.
            </p>
          </div>
          <div className="flex mt-6 mb-10 items-center container mx-auto gap-10 justify-center flex-wrap">
            <img
              src={logo1}
              alt="Agency Seal 1"
              className="h-[150px] w-[150px]"
            />
            <img
              src={logo2}
              alt="Agency Seal 2"
              className="h-[150px] w-[150px]"
            />
            <img
              src={logo3}
              alt="Agency Seal 3"
              className="h-[150px] w-[150px]"
            />
            <img
              src={logo4}
              alt="Agency Seal 4"
              className="h-[150px] w-[150px]"
            />
          </div>

          <div className="bg-[#FCF7EE] py-8">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 items-center gap-10">
              {/* Image Section */}
              <div className="flex justify-center md:justify-start">
                <img
                  src={baby}
                  alt="Child Reading"
                  className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
                />
              </div>

              {/* Text and Logos Section */}
              <div className="text-center md:text-left">
                <h3
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[40px] text-[28px] font-semibold mb-4"
                >
                  Partnerships & Accreditation
                </h3>
                <p
                  style={{ fontFamily: "poppins" }}
                  className="mb-4 text-sm sm:text-base lg:text-lg"
                >
                  AngelWatch is the only national safety accreditation program
                  built exclusively for early childhood and educational
                  facilities.
                </p>
                <p
                  style={{ fontFamily: "Fredoka" }}
                  className="mb-4 text-[#5F5AF0] text-[26px] font-medium"
                >
                  Our program is partnered with:
                </p>

                {/* Logos Row */}
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-6 mb-4">
                  <img
                    src={red}
                    alt="Red Cross"
                    className="w-32 sm:w-40 md:w-48 h-auto"
                  />
                  <img
                    src={reds}
                    alt="Red Cross"
                    className="w-28 sm:w-36 md:w-44 h-auto"
                  />
                </div>

                {/* Backed By Section */}
                <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 sm:gap-8 mt-6">
                  <p
                    style={{ fontFamily: "Fredoka" }}
                    className="text-[#5F5AF0]   text-[26px] "
                  >
                    And backed by:
                  </p>
                  <img
                    className="w-20 sm:w-28 md:w-32 h-auto"
                    src={logo4}
                    alt="Homeland Security"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-6xl mx-auto lg:mt-16 mt-6 lg:mb-6 lg:mb-4 ">
          <h2 className="lg:text-3xl text-[28px] text-black p-2 mb-40 font-bold text-center mb-12">
            Prepare to Protect Lives — Get Certified Today
          </h2>

          <Package />
        </div>
        <div className="max-w-7xl mb-10 mx-auto px-4 sm:px-6 lg:px-8 ">
          <div className="bg-[#2FB57C] border-4 border-white rounded-lg flex flex-col md:flex-row items-center justify-between p-6 md:p-8 lg:p-10">
            {/* Text Section */}
            <div className="text-center md:text-left mb-6 md:mb-0 md:mr-6 w-full md:w-2/3">
              <h2 className="text-2xl sm:text-3xl lg:text-[40px] font-bold text-white leading-tight">
                Get certified. Stay compliant. Be ready.
              </h2>
              <p className="text-sm sm:text-base md:text-lg lg:text-[17px] text-white mt-4">
                This training protects children, shields your license, and
                proves—on paper—that you're not just compliant, you're prepared.
              </p>
            </div>

            {/* Button Section */}
            <div className="w-full md:w-auto text-center md:text-right">
              <button className="bg-[#F0AA00] text-white text-sm sm:text-base lg:text-[19px] w-full md:w-[280px] py-3 px-6 rounded-full hover:bg-yellow-500 transition">
                Protect Your School Now
              </button>
            </div>
          </div>
        </div>

        {/* Pricing Section */}

        {/* Testimonials & Email */}
        <Review reviews={reviews} />

        {/* Footer Bar */}
      </div>
      <Footer />
    </>
  );
}
